export const INITIATE = 'INITIATE';
export const LOAD_DROP_FILES = 'LOAD_DROP_FILES';
export const ADD_PEAK = 'ADD_PEAK';
export const ADD_PEAKS = 'ADD_PEAKS';
export const CHANGE_PEAK_SHAPE = 'CHANGE_PEAK_SHAPE';
export const DELETE_PEAK_NOTATION = 'DELETE_PEAK_NOTATION';
export const SHIFT_SPECTRUM = 'SHIFT_SPECTRUM';
export const SET_X_DOMAIN = 'SET_X_DOMAIN';
export const SET_Y_DOMAIN = 'SET_Y_DOMAIN';
export const SET_ORIGINAL_DOMAIN = 'SET_ORIGINAL_DOMAIN';
export const SET_WIDTH = 'SET_WIDTH';
export const SET_DIMENSIONS = 'SET_DIMENSIONS';
export const SET_SELECTED_TOOL = 'SET_SELECTED_TOOL';
export const SET_SELECTED_FILTER = 'SET_SELECTED_FILTER';
export const CHANGE_SPECTRUM_SETTING = 'CHANGE_SPECTRUM_SETTING';
export const CHANGE_SPECTRUM_TYPE = 'CHANGE_SPECTRUM_TYPE';
export const FULL_ZOOM_OUT = 'FULL_ZOOM_OUT';
export const CHANGE_VISIBILITY = 'CHANGE_VISIBILITY';
export const CHANGE_ACTIVE_SPECTRUM = 'CHANGE_ACTIVE_SPECTRUM';
export const CHANGE_SPECTRUM_COLOR = 'CHANGE_SPECTRUM_COLOR';
export const ADD_INTEGRAL = 'ADD_INTEGRAL';
export const DELETE_INTEGRAL = 'DELETE_INTEGRAL';
export const TOGGLE_REAL_IMAGINARY_VISIBILITY = 'TOGGLE_REAL_IMAGINARY_VISIBILITY';
export const SET_ZOOM = 'SET_ZOOM';
export const ADD_MOLECULE = 'ADD_MOLECULE';
export const SET_MOLECULE = 'SET_MOLECULE';
export const DELETE_MOLECULE = 'DELETE_MOLECULE';
export const FLOAT_MOLECULE_OVER_SPECTRUM = 'FLOAT_MOLECULE_OVER_SPECTRUM';
export const TOGGLE_MOLECULE_ATOM_NUMBER = 'TOGGLE_MOLECULE_ATOM_NUMBER';
export const CHANGE_FLOAT_MOLECULE_POSITION = 'CHANGE_FLOAT_MOLECULE_POSITION';
export const CHANGE_MOLECULE_LABEL = 'CHANGE_MOLECULE_LABEL';
export const SET_CORRELATION = 'SET_CORRELATION';
export const SET_CORRELATIONS = 'SET_CORRELATIONS';
export const DELETE_CORRELATION = 'DELETE_CORRELATION';
export const SET_CORRELATIONS_MF = 'SET_CORRELATIONS_MF';
export const SET_CORRELATIONS_TOLERANCE = 'SET_CORRELATIONS_TOLERANCE';
export const DELETE_SPECTRA = 'DELETE_SPECTRA';
export const CHANGE_SPECTRUM_DISPLAY_VIEW_MODE = 'CHANGE_SPECTRUM_DISPLAY_VIEW_MODE';
export const RESIZE_INTEGRAL = 'RESIZE_INTEGRAL';
export const BRUSH_END = 'BRUSH_END';
export const RESET_DOMAIN = 'RESET_X_DOMAIN';
export const ENABLE_FILTER = 'ENABLE_FILTER';
export const DELETE_FILTER = 'DELETE_FILTER';
export const DELETE_SPECTRA_FILTER = 'DELETE_SPECTRA_FILTER';
export const APPLY_ZERO_FILLING_FILTER = 'APPLY_ZERO_FILLING_FILTER';
export const APPLY_APODIZATION_FILTER = 'APPLY_APODIZATION_FILTER';
export const APPLY_FFT_FILTER = 'APPLY_FFT_FILTER';
export const CALCULATE_MANUAL_PHASE_CORRECTION_FILTER = 'CALCULATE_MANUAL_PHASE_CORRECTION_FILTER';
export const CALCULATE_BASE_LINE_CORRECTION_FILTER = 'CALCULATE_BASE_LINE_CORRECTION_FILTER';
export const CALCULATE_APODIZATION_FILTER = 'CALCULATE_APODIZATION_FILTER`';
export const CALCULATE_ZERO_FILLING_FILTER = 'CALCULATE_ZERO_FILLING_FILTER`';
export const APPLY_MANUAL_PHASE_CORRECTION_FILTER = 'APPLY_MANUAL_PHASE_CORRECTION_FILTER';
export const APPLY_AUTO_PHASE_CORRECTION_FILTER = 'APPLY_AUTO_PHASE_CORRECTION_FILTER';
export const APPLY_ABSOLUTE_FILTER = 'APPLY_ABSOLUTE_FILTER';
export const DISABLE_FILTER_LIVE_PREVIEW = 'DISABLE_FILTER_LIVE_PREVIEW`';
export const SET_VERTICAL_INDICATOR_X_POSITION = 'SET_VERTICAL_INDICATOR_X_POSITION';
export const AUTO_PEAK_PICKING = 'AUTO_PEAK_PICKING';
export const OPTIMIZE_PEAKS = 'OPTIMIZE_PEAKS';
export const AUTO_RANGES_DETECTION = 'AUTO_RANGES_DETECTION';
export const AUTO_ZONES_DETECTION = 'AUTO_ZONES_DETECTION';
export const DELETE_RANGE = 'DELETE_RANGE';
export const DELETE_1D_SIGNAL = 'DELETE_1D_SIGNAL';
export const SET_SELECTED_OPTIONS_PANEL = 'SET_SELECTED_OPTIONS_PANEL';
export const SET_LOADING_FLAG = 'SET_LOADING_FLAG';
export const RESET_SELECTED_TOOL = 'RESET_SELECTED_TOOL';
export const SET_SPECTRUMS_VERTICAL_ALIGN = 'SET_SPECTRUMS_VERTICAL_AlIGN';
export const SAVE_AS_SVG = 'SAVE_AS_SVG';
export const CHANGE_INTEGRAL_DATA = 'CHANGE_INTEGRAL_DATA';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const CHANGE_INTEGRAL_SUM = 'CHANGE_INTEGRAL_SUM';
export const ADD_BASE_LINE_ZONE = 'ADD_BASE_LINE_ZONE';
export const DELETE_BASE_LINE_ZONE = 'DELETE_BASE_LINE_ZONE';
export const APPLY_BASE_LINE_CORRECTION_FILTER = 'APPLY_BASE_LINE_CORRECTION_FILTER';
export const SET_KEY_PREFERENCES = 'SET_KEY_PREFERENCES';
export const APPLY_KEY_PREFERENCES = 'APPLY_KEY_PREFERENCES';
export const RESIZE_RANGE = 'RESIZE_RANGE';
export const CHANGE_RANGE_SUM = 'CHANGE_RANGE_SUM';
export const ADD_RANGE = 'ADD_RANGE';
export const SET_2D_LEVEL = 'SET_2D_LEVEL';
export const ADD_2D_ZONE = 'ADD_2D_ZONE';
export const DELETE_2D_ZONE = 'DELETE_2D_ZONE';
export const DELETE_2D_SIGNAL = 'DELETE_2D_SIGNAL';
export const SET_2D_SIGNAL_PATH_LENGTH = 'SET_2D_SIGNAL_PATH_LENGTH';
export const ADD_MISSING_PROJECTION = 'ADD_MISSING_PROJECTION';
export const SET_FILTER_SNAPSHOT = 'SET_FILTER_SNAPSHOT';
export const CHANGE_RANGE_RELATIVE = 'CHANGE_RANGE_RELATIVE';
export const CHANGE_RANGE_SIGNAL_VALUE = 'CHANGE_RANGE_SIGNAL_VALUE';
export const CHANGE_RANGE_SIGNAL_KIND = 'CHANGE_RANGE_SIGNAL_KIND';
export const SAVE_EDITED_RANGE = 'SAVE_EDITED_RANGE';
export const UNLINK_RANGE = 'UNLINK_RANGE';
export const SET_DIAID_RANGE = 'SET_DIAID_RANGE';
export const CHANGE_INTEGRAL_RELATIVE = 'CHANGE_INTEGRAL_RELATIVE';
export const ALIGN_SPECTRA = 'ALIGN_SPECTRA';
export const CHANGE_ZONE_SIGNAL_VALUE = 'CHANGE_ZONE_SIGNAL_VALUE';
export const CHANGE_ZONE_SIGNAL_KIND = 'CHANGE_ZONE_SIGNAL_KIND';
export const SAVE_EDITED_ZONE = 'SAVE_EDITED_ZONE';
export const UNLINK_ZONE = 'UNLINK_ZONE';
export const SET_DIAID_ZONE = 'SET_DIAID_ZONE';
export const PREDICT_SPECTRA = 'PREDICT_SPECTRA';
export const SET_SPECTRA_SAME_TOP = 'SET_SPECTRA_SAME_TOP';
export const RESET_SPECTRA_SCALE = 'RESET_SPECTRA_SCALE';
export const SET_MOUSE_OVER_DISPLAYER = 'SET_MOUSE_OVER_DISPLAYER';
export const APPLY_MULTIPLE_SPECTRA_FILTER = 'APPLY_MULTIPLE_SPECTRA_FILTER';
export const ADD_EXCLUSION_ZONE = 'ADD_EXCLUSION_ZONE';
export const DELETE_EXCLUSION_ZONE = 'DELETE_EXCLUSION_ZONE';
export const CHANGE_RANGES_SUM_FLAG = 'CHANGE_RANGES_SUM_FLAG';
export const CHANGE_INTEGRALS_SUM_FLAG = 'CHANGE_INTEGRALS_SUM_FLAG';
export const CHANGE_ZONES_NOISE_FACTOR = 'CHANGE_ZONES_NOISE_FACTOR';
export const UPDATE_RANGE = 'UPDATE_RANGE';
export const SHOW_MULTIPLICITY_TREES = 'SHOW_MULTIPLICITY_TREES';
export const SHOW_RANGES_INTEGRALS = 'SHOW_RANGES_INTEGRALS';
export const AUTO_RANGES_SPECTRA_PICKING = 'AUTO_RANGES_SPECTRA_PICKING';
export const AUTO_ZONES_SPECTRA_PICKING = 'AUTO_ZONES_SPECTRA_PICKING';
export const SHOW_ZONES = 'SHOW_ZONES';
export const SHOW_ZONES_SIGNALS = 'SHOW_ZONES_SIGNALS';
export const SHOW_ZONES_PEAKS = 'SHOW_ZONES_PEAKS';
export const GENERATE_SPECTRUM_FROM_PUBLICATION_STRING = 'GENERATE_SPECTRUM_FROM_PUBLICATION_STRING';
export const RESURRECTING_SPECTRUM_FROM_RANGES = 'RESURRECTING_SPECTRUM_FROM_RANGES';
export const RESURRECTING_SPECTRUM_FROM_JCAMP = 'RESURRECTING_SPECTRUM_FROM_JCAMP';
export const SHOW_J_GRAPH = 'SHOW_J_GRAPH';
export const SET_AUTOMATIC_ASSIGNMENTS = 'SET_AUTOMATIC_ASSIGNMENTS';
export const TOGGLE_PEAKS_VIEW_PROPERTY = 'TOGGLE_PEAKS_VIEW_PROPERTY';
export const ORDER_MULTIPLE_SPECTRA_ANALYSIS = 'ORDER_MULTIPLE_SPECTRA_ANALYSIS';
export const APPLY_SIGNAL_PROCESSING_FILTER = 'APPLY_SIGNAL_PROCESSING_FILTER';
export const IMPORT_SPECTRA_META_INFO = 'IMPORT_SPECTRA_META_INFO';
export const TOGGLE_SPECTRA_LEGEND = 'TOGGLE_SPECTRA_LEGEND';
export const RECOLOR_SPECTRA_COLOR = 'RECOLOR_SPECTRA_COLOR';
export const ORDER_SPECTRA = 'ORDER_SPECTRA';
